"use client";
import { useState } from "react";
import { Stack, Heading, Button, Icon } from "@chakra-ui/react";
import { useSectionHeadingVariant } from "@/theme/components/useSectionHeading";
import AccordionComponent, { AccordionProps } from "./accordion";
import { BUTTON_VARIANTS } from "@/theme/components/button";
import {
  MdKeyboardDoubleArrowDown,
  MdKeyboardDoubleArrowUp,
} from "@onemind-services-llc/react-icons-ng/md";

type Props = {
  items: AccordionProps[];
  title?: string | null;
};

const AccordionList = (props: Props) => {
  const HeadingVariant = useSectionHeadingVariant();
  const { items, title = "Frequently Asked Questions (FAQs)" } = props;
  const [showAll, setShowAll] = useState(false);
  const itemsToShow = showAll ? items.length : 6;
  return (
    <Stack spacing={10}>
      {title && (
        <Heading as="h3" variant={HeadingVariant} textAlign={"center"}>
          {title}
        </Heading>
      )}
      <Stack>
        {items.slice(0, itemsToShow).map((item, index) => {
          return <AccordionComponent key={index} {...item} />;
        })}
        ;
        {items.length > 6 &&
          (!showAll ? (
            <Button
              variant={BUTTON_VARIANTS.IDEAL}
              onClick={() => setShowAll(true)}
              w={"fit-content"}
              alignSelf={"center"}
              mt={5}
            >
              View More
              <Icon as={MdKeyboardDoubleArrowDown} ml={2} />
            </Button>
          ) : (
            <Button
              variant={BUTTON_VARIANTS.IDEAL}
              onClick={() => setShowAll(false)}
              w={"fit-content"}
              alignSelf={"center"}
              mt={5}
            >
              View Less
              <Icon as={MdKeyboardDoubleArrowUp} ml={2} />
            </Button>
          ))}
      </Stack>
    </Stack>
  );
};

export default AccordionList;
